import { PATTERNS } from './validations';
import { COLORS } from './styles';

export const PASSWORD_RULES = [
  {
    rule: PATTERNS.PASSWORD.LOWER_CASE_CHARACTER,
    title: 'password.validation.lowerCase',
  },
  {
    rule: PATTERNS.PASSWORD.UPPER_CASE_CHARACTER,
    title: 'password.validation.upperCase',
  },
  {
    rule: PATTERNS.PASSWORD.NUMERIC_CHARACTER,
    title: 'password.validation.number',
  },
  {
    rule: PATTERNS.PASSWORD.SPECIAL_CHARACTER,
    title: 'password.validation.specCharacter',
  },
  {
    rule: PATTERNS.PASSWORD.MIN_LENGTH,
    title: 'password.validation.charactersNumber',
  },
];

export const PASSWORD_STATUS = {
  DEFAULT: 'default',
  DANGER: 'danger',
  DONE: 'done',
};

export const VALIDATION_ICONS = {
  danger: {
    name: 'close-bold',
    color: { fill: COLORS.orangePink },
  },
  done: {
    name: 'check-b',
    color: { fill: COLORS.greenLime },
  },
  default: {
    name: 'bullet',
    color: { fill: COLORS.black },
  },
};



// WEBPACK FOOTER //
// ./src/constants/passwordRules.js